export enum StructCapDealType {
  SENIOR_SECURED_DEBT = 'SENIOR_SECURED_DEBT',
  ROYALTY_MONETIZATION = 'ROYALTY_MONETIZATION',
  SYNTHETIC_ROYALTY = 'SYNTHETIC_ROYALTY',
  STRUCTURED_EQUITY = 'STRUCTURED_EQUITY',
  CONVERTIBLE_NOTE = 'CONVERTIBLE_NOTE',
  SECOND_LIEN_MEZZ_PIK_PREF = 'SECOND_LIEN_MEZZ_PIK_PREF',
  EQUITY_ASSIST = 'EQUITY_ASSIST',
}

export const StructCapCRMDealLabels: Record<StructCapDealType, string> = {
  [StructCapDealType.SENIOR_SECURED_DEBT]: 'Senior Secured Debt',
  [StructCapDealType.ROYALTY_MONETIZATION]: 'Royalty Monetization',
  [StructCapDealType.SYNTHETIC_ROYALTY]: 'Synthetic Royalty',
  [StructCapDealType.STRUCTURED_EQUITY]: 'Structured Equity',
  [StructCapDealType.CONVERTIBLE_NOTE]: 'Convertible Note',
  [StructCapDealType.SECOND_LIEN_MEZZ_PIK_PREF]: '2nd Lien/Mezz/PIK Pref',
  [StructCapDealType.EQUITY_ASSIST]: 'Equity Assist',
};
